module.exports = __webpack_public_path__ + "img/hydrocompression.c0f5f641.jpg";